export default __webpack_public_path__ + "static/media/svg-5.c0526e5c.svg";